import React, { useEffect, useState } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css"; 
import "../../App.css";

function DateRangeP({ selectedDate, setSelectedDate }) {
    const [range, setRange] = useState([
        {
            startDate: selectedDate.startDate,
            endDate: selectedDate.endDate,
            key: "selection",
        },
    ]);

    const [showPicker, setShowPicker] = useState(false);
    const togglePicker = () => setShowPicker(!showPicker);

    const formatDate = (date) => {
        return date.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    useEffect(() => {
        setSelectedDate({
            startDate: range[0].startDate,
            endDate: range[0].endDate,
        });
    }, [range, setSelectedDate]);
    
    return (
        <>
         <div style={{ position: "relative", display: "inline-block" }}>
            {/* Button dengan label range */}
            <button
                onClick={togglePicker}
                style={{
                    padding: "10px 20px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    background: "#fff",
                    cursor: "pointer",
                }}
            >
                {`${formatDate(range[0].startDate)} - ${formatDate(range[0].endDate)}`}
            </button>

            {/* Date range picker */}
            {showPicker && (
                <div
                    className="date-range-container"
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                       
                    }}
                >
                    <DateRange
                        editableDateInputs={true}
                        onChange={item => setRange([item.selection])}
                        moveRangeOnFirstSelection={false}
                        ranges={range}
                    />
                    <div style={{ textAlign: "right", padding: "10px",backgroundColor: "#ffffff" }}>
                        <button
                            onClick={() => setShowPicker(false)}
                            style={{
                                padding: "5px 10px",
                                border: "none",
                                borderRadius: "3px",
                                background: "#00b2ff",
                                color: "#fff",
                                cursor: "pointer",
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
        </>
    )
}

export default DateRangeP